/**
 * 清冊類型常數
 * 供 carbonFootprint 各子頁面共用判斷，避免散落魔術數字與重複邏輯。
 *
 * 使用方式：
 *   import { InventoryType, isInventoryType } from '../constants/inventoryType';
 *   if (isInventoryType(itemObj?.planType, InventoryType.MANUFACTURING)) { ... }
 *   if (planType === InventoryType.HOSPITAL) { ... }
 */

/** 清冊類型枚舉值（對應後端 subitemNo） */
export const InventoryType = Object.freeze({
  /** 0 - 通用行業 */
  GENERAL: "0",
  /** 1 - 製造業 */
  MANUFACTURING: "1",
  /** 2 - 服務業 */
  SERVICE: "2",
  /** 3 - 大專院校 */
  UNIVERSITY: "3",
  /** 4 - 醫院 */
  HOSPITAL: "4",
  /** 5 - 運輸業 */
  TRANSPORTATION: "5",
  /** 6 - 政府機關 */
  GOVERNMENT: "6",
});

/**
 * 判斷當前 planType 是否為指定清冊類型（支援 number/string）
 * @param {string|number|undefined|null} planType - 表單或 itemObj 的 planType
 * @param {string} type - InventoryType 的某個值，例如 InventoryType.MANUFACTURING
 * @returns {boolean}
 */
export function isInventoryType(planType, type) {
  if (planType == null || type == null) return false;
  return String(planType) === String(type);
}

/**
 * 是否為製造業
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isManufacturing(planType) {
  return isInventoryType(planType, InventoryType.MANUFACTURING);
}

/**
 * 是否為服務業
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isService(planType) {
  return isInventoryType(planType, InventoryType.SERVICE);
}

/**
 * 是否為大專院校
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isUniversity(planType) {
  return isInventoryType(planType, InventoryType.UNIVERSITY);
}

/**
 * 是否為醫院
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isHospital(planType) {
  return isInventoryType(planType, InventoryType.HOSPITAL);
}

/**
 * 是否為運輸業
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isTransportation(planType) {
  return isInventoryType(planType, InventoryType.TRANSPORTATION);
}

/**
 * 是否為政府機關
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isGovernment(planType) {
  return isInventoryType(planType, InventoryType.GOVERNMENT);
}

/**
 * 是否為通用行業
 * @param {string|number|undefined|null} planType
 * @returns {boolean}
 */
export function isGeneral(planType) {
  return isInventoryType(planType, InventoryType.GENERAL);
}
